import * as _ from 'lodash';
import { PageBase, PageOptionsBase } from '../../Common/PageBase';
import { DatatableApi, Datatable, DatatableOptions } from '../../Widgets/Datatable'
import { Utils } from '../../Utils/Utils';
import { DateUtils } from '../../Utils/DateUtils';

var tableDom = "<'row'<'col-sm-6'l><'col-sm-6'>>" + "<'row'<'col-sm-12'tr>>" + "<'row'<'col-sm-5'i><'col-sm-7'p>>";

export interface ConfigurationPageOptions extends PageOptionsBase {
    urlList: string;
    urlDetail: string;
    localizer: {
        StatusEnabled: string;
        StatusDisabled: string;
        DetailsLink: string;
    }
}

export class ConfigurationPage extends PageBase<ConfigurationPageOptions> {

    private _tableOptions: DatatableOptions;
    private _table: Datatable;
    private _tableId: string;

    constructor(options: ConfigurationPageOptions) {
        super(options);

        var getDetailUrl = (rowData: any): string => (`${options.urlDetail}/${rowData.Id}`);

        this._tableId = "tableConfigurations";
        this._tableOptions = {
            url: this._options.urlList,
            dom: tableDom,
            rowId: 'Version',
            autoWidth: true,
            pageLength: 100,
            lengthMenu: [[20, 100, 200, -1], [20, 100, 200, "All"]],
            columns: [
                {
                    data: 'Activated',
                    render: (data: any, type: any, rowData: any) =>
                        (`<span id='spnActivated${rowData.Id}'>${DateUtils.toDefaultWithTimeExt(data, false)}</span>`),
                },
                {
                    data: "Version"
                },
                {
                    data: "Status"
                },
                {
                    data: '',
                    sortable: false,
                    render: (data: any, type: any, rowData: any) =>
                        (`<a id='lnkDetail${rowData.Id}' href='${getDetailUrl(rowData)}'>${options.localizer.DetailsLink}</a>`)
                }
            ],
            order: [[1, "desc"]],
        };
    }

    init(): void {
        if (Utils.isNullOrUndefined(this._tableOptions))
            return;
        this._table = new Datatable(this._tableId, this._tableOptions);

        var exportBounsButton = <HTMLInputElement>document.getElementById("btnUpdateExportBounsAction");
        if (exportBounsButton != null) {
            exportBounsButton.onclick = () => {
                var errorExportBounsButton = <HTMLInputElement>document.getElementById("spnExportBounsValidation");
                if (errorExportBounsButton != null) {
                    errorExportBounsButton.hidden = true;
                }
            };
        }
    }
}


/** WEBPACK FOOTER **
 ** ./Typescript/Pages/ProgressiveBonuses/ConfigurationPage.ts
 **/